<template>
  <div style="background: white;padding: 5px;">
    <b>{{ item.UF_NUMBER }}</b>
    <span>{{ item.UF_NAME }}</span>
  </div>
</template>

<script>
export default {
  props: {
    item: { required: true },
    searchText: { required: true }
  }
};
</script>
